import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Star } from 'lucide-react';
import { GoldButton } from './ui/GoldButton';
export function HeroSection() {
  return <section className="relative w-full bg-[#1B2141] text-[#FAF6F0] overflow-hidden py-16 md:py-24" data-id="element-98">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-99">
        <Star className="absolute top-10 left-[10%] w-4 h-4 text-[#FAF6F0]" data-id="element-100" />
        <Star className="absolute top-20 right-[15%] w-6 h-6 text-[#FAF6F0]" data-id="element-101" />
        <Moon className="absolute top-32 left-[5%] w-12 h-12 text-[#FAF6F0]" data-id="element-102" />
        <Star className="absolute bottom-20 left-[20%] w-5 h-5 text-[#FAF6F0]" data-id="element-103" />
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-8 relative z-10" data-id="element-104">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-16" data-id="element-105">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex-1 text-center lg:text-left" data-id="element-106">
            <div className="flex justify-center lg:justify-start mb-6" data-id="element-107">
              <Moon className="w-8 h-8 text-[#C9A96E] fill-[#C9A96E]" data-id="element-108" />
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight mb-8 text-[#FAF6F0]" data-id="element-109">
              ¿Te despiertas a las 3 AM… <br className="hidden md:block" data-id="element-110" />
              <span className="italic text-[#C9A96E]" data-id="element-111">
                y ya no vuelves a dormir?
              </span>
            </h1>

            <div className="space-y-6 text-lg md:text-xl text-[#FAF6F0]/90 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-112">
              <p data-id="element-113">
                Hay un tipo de cansancio que no se arregla con "acuéstate más
                temprano".
              </p>
              <p data-id="element-114">
                Es el cansancio de despertarte en la madrugada — entre las 2 y
                las 4 — abrir los ojos… y sentir cómo tu mente se prende sola.
              </p>
              <p data-id="element-115">
                No estás pensando "cosas importantes". Estás pensando lo mismo
                de siempre, pero con el volumen al máximo.
              </p>
              <p className="font-medium text-[#C9A96E]" data-id="element-116">
                Este PDF existe para un solo propósito: darte un protocolo
                exacto para ese momento… sin rutinas eternas, sin culpa, sin
                pelear contigo.
              </p>
            </div>

            <div className="mt-10 flex flex-col items-center lg:items-start gap-3" data-id="element-117">
              <div className="mb-2" data-id="element-118">
                <span className="bg-[#C9A96E] text-[#1B2141] font-bold text-sm px-4 py-1.5 rounded-full tracking-wide shadow-md" data-id="element-119">
                  🔥 68% OFF
                </span>
              </div>
              <GoldButton className="min-w-[280px]" data-id="element-120">
                Quiero el Protocolo —{' '}
                <span className="line-through opacity-60 mr-1" data-id="element-121">$19</span> $6.39
              </GoldButton>
              <p className="text-sm text-[#FAF6F0]/70 flex items-center gap-2" data-id="element-122">
                <span className="w-2 h-2 rounded-full bg-[#C9A96E]" data-id="element-123"></span>
                Acceso inmediato · PDF + imprimibles
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 w-full max-w-md lg:max-w-full" data-id="element-124">
            <div className="relative" data-id="element-125">
              <div className="absolute -inset-4 bg-[#C9A96E]/20 rounded-2xl blur-xl" data-id="element-126"></div>
              <img src="https://cdn.magicpatterns.com/uploads/iAVkwp6tvaUUyYosU9uyNm/heylloyd-image-_el_club_de_las_3am.png" alt="El Club de las 3:00 AM en tablet y móvil sobre mesa de noche" className="relative rounded-xl shadow-2xl border border-[#FAF6F0]/10 w-full h-auto" data-id="element-127" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}